<template>
	<el-card>
		<div slot="header" class="clearfix">
		<el-button type="danger" @click="deleteChange(sels)" :disabled="this.sels.length === 0"> 批量删除</el-button>
		</div>
		<el-table v-loading="loading" ref="multipleTable" :data="commentList" tooltip-effect="dark" style="width: 100%" @selection-change="selsChange">
			<el-table-column type="selection" width="55" ></el-table-column> 
			<el-table-column prop="id" label="ID" width="100">
			</el-table-column>
			<el-table-column label="评论人">
				<template slot-scope="scope">
					<el-image style="width: 40px; height: 40px" :src="scope.row.userInfo.avatar"></el-image>
				</template>
			</el-table-column>
			<el-table-column prop="content" label="内容" show-overflow-tooltip>
			</el-table-column>
			<el-table-column prop="create_time" :formatter="$f.timeFormat" label="评论时间">
			</el-table-column>
			<el-table-column label="管理" width="200">
				<template slot-scope="scope">
					<!-- <el-button>编辑</el-button> -->
					<el-popconfirm style="margin-left: 5px;" confirmButtonText='确定' cancelButtonText='取消' @confirm="commentDel(scope.row.id,scope.$index)"
					 icon="el-icon-info" iconColor="red" title="确定删除？">
						<el-button slot="reference" type="danger">删除</el-button>
					</el-popconfirm>
				</template>
			</el-table-column>
		</el-table>
		<el-pagination @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pagesize" layout="total,prev,pager,next" :total="commmentLength"></el-pagination>
	</el-card>
</template>

<script>
	export default {
		data() {
			return {
				sels: [],//选中的值显示
				currentPage: 1,
				pagesize: 0,
				topic_id: 1,
				commentList: [],
				commmentLength: 0,
				loading:false
			}
		},
		created() {
			this.getCommentList();
		},
		methods: {
			handleCurrentChange(currentPage) {
				this.currentPage = currentPage;
				this.getCommentList();
			},
			getCommentList() {
				this.loading = true;
				this.$H.get("Comment/list", {
					page: this.currentPage
				}).then((res) => {
					this.commentList = res.result.data;
					this.pagesize = res.result.per_page;
					this.commmentLength = res.result.total;
					this.loading = false;
				})
			},
			commentDel(id, index) {
				this.$H.post("comment/del", {
					id: id
				}).then(res => {
					if (res.code == 200) {
						this.commentList.splice(index, 1);
						this.$message.success('删除成功');
					}
				})
			},
			selsChange(sels) {
			    this.sels = sels 
			},
			deleteChange(index) {
			        var ids= this.sels.map(item => item.id).join()//获取所有选中行的id组成的字符串，以逗号分隔
			        console.log(ids)
			        this.$confirm('此操作将永久删除选中数据, 是否继续?', '提示', {
			          confirmButtonText: '确定',
			          cancelButtonText: '取消',
			          type: 'warning'
			        }).then(() => {      
			            this.$H.post("comment/del", {
			            	id: ids
			            }).then(res => {
			            	if (res.code == 200) {
			            		this.$message.success('删除成功');
								setTimeout(()=>{
								          location.reload();
								        },1000)
			            	}
			            })
			          }).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			}
		}
	}
</script>
</script>

<style>
</style>
